module.exports = __webpack_public_path__ + "media/src/application/media/rooms/many_function3-3ba681fd57baa0a8b589c37754ddbca3.jpg";